import { httpInstance } from '@/clients/http.request';
import { urlResponsabilidadCivil, urlMailResponsabilidadCivil } from '@/helpers';
import { sendFallbackEmail } from '@/composables/useFallbackEmail';

export const fetchDatos = async ({ rootState, commit }) => {
   const id_poliza = rootState.poliza.poliza.id_poliza;
   const { data } = await httpInstance.get(urlResponsabilidadCivil, { id_poliza });
   commit('setDatos', data);
   return data;
};

export const saveDatos = async ({ rootState, commit }, payload) => {
   const id_poliza = rootState.poliza.poliza.id_poliza;
   const { data } = await httpInstance.post(urlResponsabilidadCivil, { id_poliza, ...payload });
   commit('setDatos', data);
   return data;
};

export const fetchDocumentos = async ({ rootState, commit, dispatch }) => {
   const files = await dispatch('art/getFiles', { id_poliza: rootState.poliza.poliza.hash_id }, { root: true });
   commit('setDocumentos', files ?? []);
   return files;
};

export const uploadDocumento = async ({ rootState, dispatch }, event) => {
   const formData = new FormData();
   event.files.forEach((file) => formData.append('files', file));
   formData.append('id_seccion', rootState.poliza.poliza.id_seccion);
   formData.append('id_cliente', rootState.poliza.poliza.id_cliente);
   formData.append('id_poliza', rootState.poliza.poliza.hash_id);
   formData.append('id_empresa', rootState.auth.usuario.id_empresa);
   formData.append('esCotizacion', false);
   return dispatch('art/postFile', formData, { root: true });
};

export const sendFinalizeEmail = async ({ rootState }) => {
   try {
      await httpInstance.post(urlMailResponsabilidadCivil, {
         id_poliza: rootState.poliza.poliza.id_poliza,
      });
   } catch (error) {
      try {
         await sendFallbackEmail({ id_poliza: rootState.poliza.poliza.id_poliza });
      } catch (fallbackError) {
         console.error('Error al enviar fallback email:', fallbackError);
      }
      throw error;
   }
};
